import HeadTittle from "../../../components/HeadTittle";
import {permissionObj} from "../../../Helpers/permission";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {AddIcon, CleanIcon, EditIcon} from "../../../components/buttons/IconButtons";
import routes from "../../../Routes/routes";
import React from "react";
import {CreateUpdateRequestApp} from "./Funtionality/CreateUpdateRequestApp";
import ButtonIcon from "../../../components/buttons/ButtonIcon";
import DivContainerBody from "../../../components/DivContainerBody";
import {CustomTextField} from "../../../components/CustomTextField";
import {MenuItem} from "@mui/material";
import {CustomSelectAndChildren} from "../../../components/CustomSelectAndChildren";
import CustomDateTimePicker from "../../../components/CustomDateTimePicker";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const CreateUpdateRequest = () => {

    const {
        DEV,
        permission,
        handleCreate,
        handleClear,
        handleChange,
        data,
        emptyFields,
        getAllDistributionCenter,
        disabled,
        getAllServiceType,
        getAllSupplier,
        id,
        isValidDeliveryAt
    } = CreateUpdateRequestApp();

    return(
        <>
            <HeadTittle name={id ? 'update' :'create'} onBack={routes.transportRequest.list}
                        divStack={
                            !id &&
                            <div className={"ml-1"}>
                                <ButtonIcon
                                    className='btn-clean-secondary-600'
                                    id='btn_d_clean'
                                    Icon={CleanIcon}
                                    onClick={handleClear}
                                    title={'clear_instances'}
                                    iconProps='btn-icon-svg-12px icon-color-general-00'
                                />
                            </div>
                        }
            >
                {(DEV || permission?.includes(permissionObj?.WEB_LOGISTIC_REQUEST_CREATE)) && (
                    <ButtonAction
                        id='btn_d_request'
                        name={id ? "update" : "create"}
                        className='btn-icon-add'
                        Icon={id ? EditIcon : AddIcon}
                        onClick={handleCreate}
                    />
                )}
            </HeadTittle>

            <DivContainerBody>
                <div className={"row mt-2"}>
                    <div className={"col-12"}>
                        <CustomTextField id={"txt_cur_item"}
                                         length={24}
                                         name={"item"}
                                         value={data.item}
                                         trans={"item"}
                                         onChange={handleChange}
                                         required={true}
                                         emptyFields={emptyFields}
                        />
                    </div>
                    <div className={"col-12"}>
                        <CustomTextField id={"txt_cur_description"}
                                         length={512}
                                         name={"description"}
                                         value={data.description}
                                         trans={"description"}
                                         onChange={handleChange}
                                         required={true}
                                         emptyFields={emptyFields}
                                         multiline={true}
                                         rows={4}
                        />
                    </div>
                    <div className="col-6">
                        <CustomSelectAndChildren
                            id="txt_cur_origin_center"
                            name="originCenterId"
                            emptyFields={emptyFields}
                            value={data.originCenterId}
                            onChange={handleChange}
                            trans="origin_center"
                            label="lbl_cur_originCenterId"
                            showNoSelectionOption={false}
                            required={true}
                        >
                            {getAllDistributionCenter?.map((item) => {
                                if (item.id === data.destinationCenterId) return null;
                                return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                            })}
                        </CustomSelectAndChildren>
                    </div>
                    <div className="col-6">
                        <CustomSelectAndChildren
                            id="txt_cur_destination_center"
                            name="destinationCenterId"
                            emptyFields={emptyFields}
                            value={data.destinationCenterId}
                            onChange={handleChange}
                            trans="destination_center"
                            label="lbl_cur_destinationCenterId"
                            showNoSelectionOption={false}
                            required={true}
                        >
                            {getAllDistributionCenter?.map((item) => {
                                if (item.id === data.originCenterId) return null;
                                return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                            })}
                        </CustomSelectAndChildren>
                    </div>
                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomDateTimePicker
                            id={'dp_cur_pickup_date'}
                            name={'departureAt'}
                            disabled={disabled}
                            onChange={(e)=>{
                                handleChange({ target: { value: e, name: 'departureAt' } });
                            }}
                            trans={'pickup_date'}
                            value={data?.departureAt}
                            required={true}
                            disablePast={true}
                            openTo={'day'}
                            emptyFields={emptyFields}
                            maxDate={data.deliveryAt ? new Date(data.deliveryAt) : undefined}
                        />
                    </div>
                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomDateTimePicker
                            id={'dp_cur_delivery_date'}
                            name={'deliveryAt'}
                            onChange={(e)=>{
                                handleChange({ target: { value: e, name: 'deliveryAt' } });
                            }}
                            disabled={!data?.departureAt}
                            trans={'delivery_date'}
                            value={data?.deliveryAt}
                            required={true}
                            disablePast={true}
                            openTo={'day'}
                            emptyFields={emptyFields}
                            minDate={data.departureAt ? new Date(data.departureAt) : undefined}
                            isValid={isValidDeliveryAt}
                            isValidText={"delivery_date_cannot_be_earlier_than_or_equal_to_pickup_date"}
                        />
                    </div>
                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        <CustomSelectAndChildren
                            id="txt_cur_service_type"
                            name="serviceTypeId"
                            emptyFields={emptyFields}
                            value={data.serviceTypeId}
                            disabled={id}
                            onChange={handleChange}
                            trans="service_type"
                            label="lbl_cur_serviceTypeId"
                            showNoSelectionOption={false}
                            required={true}
                        >
                            {getAllServiceType?.map((item) => {
                                return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                            })}
                        </CustomSelectAndChildren>
                    </div>
                    <div className='col-sm-12 col-xxl-6 col-lg-6'>
                        {(() => {
                            const filteredSuppliers = getAllSupplier?.filter(
                                item => item.serviceType?.id === data.serviceTypeId
                            ) || [];

                            return (
                                <CustomSelectAndChildren
                                    id="txt_cur_supplier_id"
                                    name="supplierId"
                                    value={data.supplierId}
                                    onChange={handleChange}
                                    trans="supplier"
                                    label="lbl_cur_supplierId"
                                    showNoSelectionOption={true}
                                    disabled={id || filteredSuppliers.length === 0}
                                >
                                    {filteredSuppliers.map(item => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.supplierCompanyName}
                                        </MenuItem>
                                    ))}
                                </CustomSelectAndChildren>
                            );
                        })()}
                    </div>
                </div>
            </DivContainerBody>
        </>
    )
}

export default CreateUpdateRequest
